import React, { Fragment } from "react";
import { Settings, Sliders } from "react-feather";
import { Link } from "react-router-dom";
import { Image, LI, P, UL } from "../../../AbstractElements";

const SettingsMenu = () => {
  return (
    <Fragment>
      <LI attrLI={{ className: "onhover-dropdown" }}  >
        <Link style={{textDecoration: 'none',color:'#212529'}}  to={`/app/organisation`}>
          <Settings />
        </Link>
        {/* <UL attrUL={{ className: "chat-dropdown onhover-show-div" }}>
          <LI>
            <div className="media">
              <span className="notification-bg bg-light-primary">
                <Sliders />
              </span>

              <div className="media-body" style={{marginLeft:10}}>
                <Link to={`/app/organisation`}>
                  <span>Organisation Settings</span>
                </Link>
              </div>
            </div>
          </LI>
        </UL> */}
      </LI>
    </Fragment>
  );
};

export default SettingsMenu;
